export function contactModal() {
    const cta = document.querySelector(".header__cta");
    const modal = document.querySelector(".contact-modal");

    if (!cta || !modal) return;

    let timer;

    function show() {
        clearTimeout(timer);
        modal.classList.add("contact-modal--active");
        cta.classList.add("header__cta--active");
    }

    function hide() {
        timer = setTimeout(() => {
            modal.classList.remove("contact-modal--active");
            cta.classList.remove("header__cta--active");
        }, 200);
    }

    cta.addEventListener("mouseenter", show);
    cta.addEventListener("mouseleave", hide);
    modal.addEventListener("mouseenter", show);
    modal.addEventListener("mouseleave", hide);
}
